import CallServer from '../../api/CallServerV2';

export async function fetchTriggerExport(level, format = 'csv', filters = null) {
    return await CallServer({
        body: { level, format, ...(filters && { filters }) },
        endpoint: '/admin/trigger_export',
    })
}

export async function fetchExports() {
    return await CallServer({
        endpoint: '/admin/get_exports',
        isGet: true
    })
}

export async function fetchExport(export_id) {
    return await CallServer({
        params: { export_id },
        endpoint: '/admin/get_export',
        isGet: true
    })
}
